import { render } from "./IdentityVerificationModal.vue?vue&type=template&id=a0131736&scoped=true"
import script from "./IdentityVerificationModal.vue?vue&type=script&lang=js"
export * from "./IdentityVerificationModal.vue?vue&type=script&lang=js"

import "./IdentityVerificationModal.vue?vue&type=style&index=0&id=a0131736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0131736"]])

export default __exports__